import { IConfig } from '@cian/config/shared';

const SUB_AGENTS_FETCH_LIMIT = 25;

export const getSubAgentsFetchLimit = (config: IConfig): number => {
  return config.get<number>('frontend-chats.SubAgentsFetchLimit') || SUB_AGENTS_FETCH_LIMIT;
};
